import { xyz_n_1of4, xyz_n_DemosAndRetrospective, xyz_7_LastRegularSession, insertInto } from './SL00000Sprint00TTR'
import { list20000Sprint06 } from '../ActivityLists/AL20000Sprint06'
import { list20000Sprint07 } from '../ActivityLists/AL20000Sprint07'
import { basicSlide, orderedListSlide } from './SLSprint00'
import { submissionPercentage } from './SLSprint00'

// Introduction to Computer Science (ICS) sprint 7 global values.
const sprint = 7
const activityList = () => { return list20000Sprint07(sprint) }
const activityListPrevious = () => { return list20000Sprint06(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

// Session 1 of 4: Tuesday
const ics_7_1of4 = () => { 
	const sprintPlanningExpectations = () => {
		return orderedListSlide('Sprint Planning', `Sprint ${sprint} Expectations:`, [
			'Similar to other sprints with a Discussion, Lab, and Reflection',
			`Similar in that we will have 2 weeks to complete sprint ${sprint}`,
			`Similar in that we have sprint ${sprint-1} Demos and Retrospectives Thursday`,
			`Different in that we have our Final Exam will be next Tuesday with in person attendance required`,
			`Different in that the Final Exam replaces the Quiz for the sprint`,
			`Different in that we will also have Sprint ${sprint+1} Planning today`,
		 ])
	}
	const activitiesReviewSprint8 = () => {
		return basicSlide('Sprint 8 Activity List and Assignments Review', [
			'Let’s open our Blackboard shell and review the Sprint 8 activity list and assignments together.' ])
	}

	const slideDeck = xyz_n_1of4(null, null, sprintAndActivityLists, sprintPlanningExpectations)
	const insertAfterActivitiesReview = 6
	return insertInto(slideDeck, activitiesReviewSprint8, insertAfterActivitiesReview)
}

// Session 2 of 4: Tuesday
const ics_7_2of4_PAaA = {
	'prework':[
		'Complete through activity 5',
		'Be prepared for Demos and Retrospectives' ],
	'announcements':[ 
		`Tuesday is your final exam, your in-person attendance is required`, '',
	],
	'agenda':[
		`Sprint ${sprint-1} Demos`,
		`Sprint ${sprint-1} Retrospective`,
		`Breakout for Sprint ${sprint-1} Retrospective`,
		'Prework for Next Class',
		'Lab' ],
}
const ics_7_2of4 = () => {
		const metricsSubmissionPercentage = () => {
			return submissionPercentage([
				{ name: 'Discussion', due:24, submitted:19 },
				{ name: 'Quiz', due:24, submitted:22 },
				{ name: 'Lab', due:24, submitted:20 },
				{ name: 'Reflection', due:24, submitted:20 }])
		}

		const retrospective = () => {
				return orderedListSlide('Class Retrospective',
					'Feedback from Assignments & Reflections', [
					`That‘S A disappointing submission percentage for sprint ${sprint-1}`,
					`Many assignments have not been graded yet`,
					'What can I do to help?' ])
		}
	return xyz_n_DemosAndRetrospective(ics_7_2of4_PAaA, ics_7_3of4_PAaA, sprintAndActivityLists, metricsSubmissionPercentage, retrospective)
}

export const ics_7_3of4_PAaA = {
	'prework':[
		'Complete through activity 7', '',
		'Be prepared for your final exam... with in-person attendance required' ],
	'announcements':[ 
		`All sprint ${sprint} announcements due Sunday`, 
		`Monday is Sprint ${sprint} Planning`
	],
	'agenda':[
		'Lab'
	],
}

const ics_7_4of4_PAaA = {
	'prework':[
		'Complete through activity 8', '',
		'Be prepared for Lab and ”Working with India”' ],
	'announcements':[ 
		`All sprint ${sprint} announcements due Sunday`, 
		'Please verify your date and time for your Class Project Presentation',
		'You should have received an email with course evaluation information', 
	],
	'agenda':[
		'Review Class Project Presentation Dates/Times and Expectations',
		'Lab',
		'Globalization and Working with India'
	],
}


const ics_7_4of4 = () => {
	return xyz_7_LastRegularSession(ics_7_4of4_PAaA, ics_8_1of1_PAaA, sprintAndActivityLists)
}

const ics_8_1of1_PAaA = {
	'prework':[
		'All sprint 7 assignment are due Sunday', '',
		`Prepare for your Class Project Presentation`,
		'All Sprint 8 assignments are due Wednesday' ],
	'announcements':[
		'TBD' ] ,
	'agenda':[
		'TBD' ]
}


export const ics_7_slidedeckTTR = [ ics_7_1of4, ics_7_2of4, null, ics_7_4of4 ]